import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormInlineErrorComponent, SsnFieldComponent } from '@k12/forms';
import { ProviderData } from '@k12/models';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-personal-information',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgxMaskDirective, FormInlineErrorComponent, SsnFieldComponent],
  providers: [provideNgxMask()],
  templateUrl: './personal-information.component.html'
})
export class PersonalInformationComponent {
  @Input() formGroup!: FormGroup;
  @Input() providerData!: ProviderData;
  @Input() providerType: string = '';
  @Input() showReviewStatus: boolean = false;

  get socialSecurityControl(): FormControl<string | null> {
    return this.formGroup.get('socialSecurityLast4') as FormControl<string | null>;
  }
}
